import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { DESCRIPTION } from '../../constants';
import { Context } from './Context';
const Description = forwardRef(({ as: Element = 'p', children, ...rest }, ref) => {
    const { id } = useContext(Context);
    return (_jsx(Element, { ref: ref, id: `${id}-description`, ...rest, children: children }));
});
Description.displayName = DESCRIPTION;
export { Description };
//# sourceMappingURL=Description.js.map